"use client";

import React from "react";
import cx from "classnames";
import styles from "./styles.module.scss";

interface LoaderProps {
    loaderClass?: any;
    size?: number; // Optional size prop to adjust the size of the loader
}

const Loader: React.FC<LoaderProps> = ({ size = 30, loaderClass }) => {
    return (
        <div
            className={cx(styles["loader-container"], loaderClass)}
            style={{ width: size, height: size }}
        ></div>
    );
};

export default Loader;
